// Module
var code = " <div id=\"app-status\"> <progress class=\"progress is-small is-info\" max=\"100\">Loading</progress> </div> ";
// Exports
export default code;